import React from 'react'

import NuevaMainCard from './mainCard'

import * as TransferenciaCrud from 'services/transferencia.service'

const DetalleTransferenciaPage = ({ location, history, match }) => {
  const [transferenciaInfo, setTransferenciaInfo] = React.useState(null)

  React.useEffect(() => {
    TransferenciaCrud.getTransferencia(match.params.idTransferencia).then(({ data }) => {
      setTransferenciaInfo(data)
    })
  }, [match.params.idTransferencia])

  return (
    <>
      {transferenciaInfo && (
        <NuevaMainCard
          history={history}
          transferenciaInfo={transferenciaInfo}
          queryParams={location.search}
        />
      )}
    </>
  )
}

export default DetalleTransferenciaPage
